var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgChave = function SvgChave(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 246.183,
    height: 143.163,
    viewBox: "0 0 65.136 37.879",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M46.112 132.795a11.788 11.788 0 0 1-11.788 11.788 11.788 11.788 0 0 1-11.788-11.788 11.788 11.788 0 0 1 11.788-11.787 11.788 11.788 0 0 1 11.788 11.787Z",
    style: {
      fill: "none",
      stroke: "green",
      strokeWidth: 9.02425,
      strokeLinecap: "round",
      paintOrder: "fill markers stroke"
    },
    transform: "translate(-18.024 -116.495)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.443 131.43h32.544c.066 0 .118.052.118.118v2.495a.118.118 0 0 1-.118.118H47.443a.118.118 0 0 1-.119-.118v-2.495c0-.066.053-.118.119-.118z",
    style: {
      fill: "none",
      stroke: "green",
      strokeWidth: 6.10963,
      strokeLinecap: "round",
      paintOrder: "fill markers stroke"
    },
    transform: "translate(-18.024 -116.495)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m62.688 145.306 16.51 8.23v.838l-1.83-.838h-14.68zm0-1.778 16.51 8.23v.889l-16.51-8.23zm0-1.854 16.51 8.28v.915l-16.51-8.306zm0-1.778 16.51 8.28v.89l-16.51-8.281zm0-1.727 16.51 8.23v.888l-16.51-8.28zm0-1.804 7.848 3.937v-3.937h8.662v9.094l-16.51-8.205z",
    style: {
      fontSize: "25.4px",
      lineHeight: 0.65,
      fontFamily: "Sinaloa-Normal",
      InkscapeFontSpecification: "Sinaloa-Normal",
      textAlign: "center",
      letterSpacing: 0,
      wordSpacing: 0,
      textAnchor: "middle",
      fill: "green",
      strokeWidth: 0.264583
    },
    transform: "translate(-18.024 -116.495)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.742 175.077h29.538v31.685H97.742Z",
    style: {
      fill: "green",
      stroke: "#000",
      strokeWidth: 7.50001,
      strokeLinecap: "round",
      paintOrder: "fill markers stroke"
    },
    transform: "translate(-18.024 -116.495)"
  }));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgChave, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/chave.f03fbed2.svg";
export { ForwardRef as ReactComponent };